import React from "react";
import { CheckIcon, UncheckIcon } from "../Icon";

const IconBadge = ({ 
  success = false, 
  status = null, 
  checkColor = "#00b341",
  uncheckColor = "#c7c7c5"
}) => {

  if (success === true || success === status) {
    return <CheckIcon color={checkColor} />;
  }

  return <UncheckIcon color={uncheckColor} />;
};

export default IconBadge;